const state = {
  todoListCnt: sessionStorage.getItem("todoListCnt") ? JSON.parse(sessionStorage.getItem("todoListCnt")) : 0,
  noticeData: sessionStorage.getItem("noticeData") ? JSON.parse(sessionStorage.getItem("noticeData")) : null,
}
const getters = {
  todoListCnt: state => state.todoListCnt,
  noticeData: state => state.noticeData
}

const actions = {
//   async getadminInfo ({ commit }, userData) {

//   }
}

const mutations = {
  'SETTODOCNT' (state, cunt) {
    state.todoListCnt = cunt
    sessionStorage.setItem("todoListCnt", cunt)
  },
  'UPDATETODOCNT' (state, data) {
    state.noticeData = data
    sessionStorage.setItem("noticeData", JSON.stringify(data))
  }
}
export default{
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/order/index.js